import { combineReducers } from 'redux';

import { customersNav, namespace as autoCompleteNamespace } from './autocomplete/customers.autocomplete.reducer';
import { customersFilterReducer, namespace as filteringNamespace } from './filtering/customers.filtering.reducer';
import { customersGrid, namespace as gridNamespace } from './grid/customers.grid.reducer';
import { ConnectedActionHandlerMap as navReducer, namespace as navNamespace } from './nav/customers.nav.reducer';
import {
  ConnectedActionHandlerMap as createLabelReducer,
  namespace as createLabelNamespace,
} from './create-label/customers.create-label.reducer';
import { customersView, namespace as viewNamespace } from './view/customers.view.reducer';
import { reduce, namespace as selectedCustomerNamespace } from './selected-customers/customers.selected-customers.reducer';
import { customerOrdersGrid, namespace as customerOrdersGridNamespace } from './customer-orders-grid/customer-orders.grid.reducer';
import { customersCombine, namespace as combineCustomersNamespace } from './combine/customers.reducer';

export const combinedReducer = combineReducers({
  [autoCompleteNamespace]: customersNav,
  [combineCustomersNamespace]: customersCombine,
  [filteringNamespace]: customersFilterReducer,
  [gridNamespace]: customersGrid,
  [navNamespace]: navReducer,
  [createLabelNamespace]: createLabelReducer,
  [viewNamespace]: customersView,
  [selectedCustomerNamespace]: reduce,
  [customerOrdersGridNamespace]: customerOrdersGrid,
});

export { namespace } from './customers.reducer.metadata';
